<script setup lang="ts">
  import { onBeforeUnmount, onMounted, ref } from 'vue'
  import type { SearchFunctionMap } from '@gat-ship/types'
  import { provideGlobalSearchDialog } from '../composables/global-search-context'
  import GlobalSearchDialog from './GlobalSearchDialog.vue'

  defineProps<{ searchFunctions?: SearchFunctionMap }>()

  const isOpen = ref(false)

  const openSearchCommand = () => {
    isOpen.value = true
  }

  const closeSearchCommand = () => {
    isOpen.value = false
  }

  provideGlobalSearchDialog({
    openSearchCommand,
    closeSearchCommand,
    isSearchCommandOpen: isOpen
  })

  const handleGlobalShortcut = (event: KeyboardEvent) => {
    if (event.ctrlKey && event.key.toLowerCase() === 'k') {
      event.preventDefault()
      openSearchCommand()
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleGlobalShortcut)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleGlobalShortcut)
  })
</script>

<template>
  <slot />
  <GlobalSearchDialog :search-functions="searchFunctions" />
</template>
